import { baseApi } from "../baseApi";

export const ordersApi = baseApi
  .enhanceEndpoints({
    addTagTypes: ["Orders", "RadiologyOrders", "LabOrders", "PharmacyOrders", "OldLabResults", "PatientVisits"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getOrders: builder.query({
        query: (payload) => ({
          url: "/v3/order/list",
          method: "POST",
          body: payload,
        }),
        providesTags: ["Orders"],
      }),
      getRadiologyOrders: builder.query({
        query: (payload) => ({
          url: "/v3/radiology/orders",
          method: "POST",
          body: payload,
        }),
        providesTags: ["RadiologyOrders"],
      }),
      getLabOrders: builder.query({
        query: (payload) => ({
          url: "/v3/lab/orders",
          method: "POST",
          body: payload,
        }),
        providesTags: ["LabOrders"],
      }),
      getOldLabResults: builder.query({
        query: (payload) => ({
          url: "/v3/lab/old/results",
          method: "POST",
          body: payload,
        }),
        providesTags: ["OldLabResults"],
      }),
      getPharmacyOrders: builder.query({
        query: (payload) => ({
          url: "/v3/pharmacy/orders",
          method: "POST",
          body: payload,
        }),
        providesTags: ["PharmacyOrders"],
      }),
      createOrder: builder.mutation({
        query: (payload) => ({
          url: "/v3/order/create",
          method: "POST",
          body: payload,
        }),
        invalidatesTags: ["Orders"],
      }),
      cancelOrder: builder.mutation({
        query: (payload) => ({
          url: "/v3/order/cancel",
          method: "POST",
          body: payload,
        }),
        invalidatesTags: ["Orders"],
      }),
      createSpecialVisit: builder.mutation({
        query: (payload) => ({
          url: "/v3/visit/v3/create",
          method: "POST",
          body: payload,
        }),
        invalidatesTags: ["Orders", "PatientVisits"],
      }),
    }),
  });

export const {
  useGetOrdersQuery,
  useLazyGetOrdersQuery,
  useGetRadiologyOrdersQuery,
  useLazyGetRadiologyOrdersQuery,
  useGetLabOrdersQuery,
  useLazyGetLabOrdersQuery,
  useGetOldLabResultsQuery,
  useLazyGetOldLabResultsQuery,
  useGetPharmacyOrdersQuery,
  useLazyGetPharmacyOrdersQuery,
  useCreateOrderMutation,
  useCancelOrderMutation,
  useCreateSpecialVisitMutation,
} = ordersApi;
